import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Divider, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Typography
} from '@mui/material';

import { Assignment, AttachMoney, AccountBalance, AccountBalanceWallet, Add, Apps, Business, CloudQueue, ContactMail, CreditCard, Dashboard,
         Description, Launch, Menu, MonetizationOn, People, Receipt, Settings } from '@mui/icons-material';

import LocalAtmIcon from '@mui/icons-material/LocalAtm';

import VendorPendingActionIcon from '../vendor/VendorPendingActionIcon';
import VendorPayoutActionIcon from '../vendor/VendorPayoutActionIcon';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
const styles = theme => ({
    navDrawerHeader: {
      backgroundColor: "rgba(0,0,0,0.2)", // header is darker than the rest of the nav drawer
      display: 'flex',
      heigth: '50px'
    },
    menuButton: {
      marginLeft: 0,
      marginRight: 5,
    },
    toolBarIcon: {
      color: theme.palette.nav.text
    },
    logoContainer: {
      display: 'flex',
      height: '50px',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 12,
    },
    list: {
      width: 196,
      marginTop: 0,
      flex: 'initial',
    },
    listNarrow: {
      width: 50,
      marginTop: 0,
      flex: 'initial',
    },
    drawerStyle: {
      height: '100%',
      top: 0,
      backgroundColor: theme.palette.nav.backgroundColor,
      fontSize: 10,
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'block',
      fontWeight: 'bold'
    },
    item: {
      paddingLeft: 12,
    },
    itemIcon: {
      minWidth: 36,
      marginRight: 4
    },
    icon: {
      color: theme.palette.nav.text,
    },
    primaryText: {
      color: theme.palette.nav.text,
    },
    listSubheader: {
      lineHeight: '24px',
      backgroundColor: theme.palette.nav.backgroundColor,   //SDW had to add this
    },
    subheaderText: {
      color: theme.palette.nav.text,
    }
});

class NavDrawer extends React.Component {

  constructor(){
    super();
    this.state = {
      open: true,
      counter: 1,
      height: window.innerHeight,
      width: window.innerWidth,
    };
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    open: true,
  };
  counter = 1;
  didToggleMenu = false;

  componentDidMount() {
    this.props.onRef(this);
    //console.log('NavDrawer.componentDidMount() - auth: ' + this.props.auth.isAuthenticated());
    // only call autoToggleMenu() the first time
    if( this.props.auth.isAuthenticated() && !this.didToggleMenu )
      this.autoToggleMenu();
  }

  componentDidUpdate() {
    //console.log( this.didToggleMenu );
    // only call autoToggleMenu() the first time
    //console.log('NavDrawer.componentDidUpdate() - auth: ' + this.props.auth.isAuthenticated());
    if( this.props.auth.isAuthenticated() && !this.didToggleMenu )
      this.autoToggleMenu();
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  goTo(route) {
    // Don't go if already on the route
    if (! this.isAlreadyOnPath(route))
      this.props.history.push(`/${route}`);
  }

  toggleDrawer = (open) => {
    this.setState({ open: open || !this.state.open});
    this.props.onToggle(this.state.open); // Notify parent
  };

  handleOpen = (ev) => {

    this.toggleDrawer(true);
  };

  // This is not getting called from onClose
  handleClose = (ev) => {

    this.toggleDrawer(false);
  };

  handleMenuClick = (ev) => {
    if( this.props.routes.navdrawer )
      this.props.routes.navdrawer.toggleDrawer();
  }

  autoToggleMenu = () =>{
    // if less than 600 & nav is open & smallScreen flag is not setState
    if( window.innerWidth < 600 && this.state.open ) {
      this.handleMenuClick();
    }
    this.didToggleMenu = true;
  }

  isAlreadyOnPath = (thePath) => {
    let currentPath = this.props.location.pathname;
    if (currentPath != null && currentPath[0] === '/')
    {
      currentPath = currentPath.slice(1);
    }
    return (currentPath === thePath);
  }

  render() {
    const classes = this.props.classes;

    // Ignore if on the partner route
    if (this.props.location.pathname.startsWith('/partner'))
    {
      return (null);
    }

    if (this.props.location.pathname.startsWith('/order'))
    {
      return (null);
    }

    if (this.props.location.pathname.startsWith('/stepperresume'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/stepperresumecustomer'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/steppersignin'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/steppersigninemail'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/verify'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('callback'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/steppercustomerauthorize'))
    {
      return (null);
    }
    if (this.props.location.pathname.startsWith('/authonlyauthorize'))
    {
      return (null);
    }

    // The app catalog used to be conditionally shown.  Leave the flag here, as we may return to conditional display.
    let showAppCatalog = true;
  
    // Bills / invoices is feature flagged
    let showDocuments = false;
    let documentLabel = "My documents";
    let showDocumentsFlag = abEnvironment.getFlagValue("showDocuments");
    if (showDocumentsFlag != null && showDocumentsFlag.flagValue === 1) {
      showDocuments = true;

      let documentTerm = this.props.auth.getDocumentTerm('documentName');
      if (documentTerm === 'documentName') {
          documentTerm = 'Document';
      }

      documentLabel = "My " + documentTerm.toLowerCase() + "s";
    }

    let invoiceName = this.props.auth.getInvoiceTerminology().toLowerCase() + 's';

    let subOrder = false;
    if (abEnvironment.getUserAttribute('a_useBudgets') !== '0' && this.props.auth.isAuthenticatedReseller()) {
      subOrder = true;
    }

    // For restricting a feature to POC only.  Uncomment to use.
    /*
    let pocEnvironment = false;
    if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
      pocEnvironment = true;
    } 
    */

    /* Statements, Charges, and Bills should only be shown if expensing is on, or if there is something to show.
       So check the feature flag, and check if there are any invoice documents. */
    let showExpensing = false;
    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }  
    let paymentSourceCount = 0;
    if (abEnvironment.getUserAttribute("ps_count")) {
      paymentSourceCount = parseInt(abEnvironment.getUserAttribute("ps_count"), 10);
    }
    if (paymentSourceCount > 0 || expensingActive === true) {
      showExpensing = true;
    }

    return (
      <div id="navDrawer">
        { this.props.auth.isAuthenticated() && (
        <Drawer
          variant="persistent"
          open={this.state.open}
          onClose={this.handleClose}
          classes={{paper: classes.drawerStyle}}
        >

            <div id="toolbar-menu" style={{width:this.props.narrow?'50px':'auto'}} className={classes.navDrawerHeader}>
              { this.props.auth.isAuthenticated() && (
                <IconButton
                  className={classes.menuButton}
                  color="default"
                  aria-label="Menu"
                  onClick={this.handleMenuClick}
                  size="large">
                  <Menu className={classes.toolBarIcon}/>
                </IconButton>
              )}
              { this.props.auth.isAuthenticated() && (
                <div className={classes.logoContainer}>
                  <img alt="AppBind Logo" height="30px" src={'/logos/appbind-logo-white-only.png'} />
                </div>
              )}
              { ! this.props.auth.isAuthenticated() && (
                <div className={classes.logoContainer}>
                  <img alt="AppBind Logo" height="30px" src={'/logos/appbind-logo-white-only.png'} />
                </div>
              )}
            </div>

            {(!this.props.auth.isUnauthenticatedCustomer()) && (
             <span>
              <List className={this.props.narrow ? classes.listNarrow : classes.list}>
                <ListItemButton selected={this.isAlreadyOnPath('home')} onClick={this.goTo.bind(this, 'home')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Dashboard className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
              </List>
              <Divider/>
             </span>
            )}
            {this.props.auth.isAuthenticatedAppBind() && (
              <List className={this.props.narrow ? classes.listNarrow : classes.list}>
                <ListItemButton selected={this.isAlreadyOnPath('accounts')} onClick={this.goTo.bind(this, 'accounts')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Business className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Accounts" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                <ListItemButton selected={this.isAlreadyOnPath('adminappsummary')} onClick={this.goTo.bind(this, 'adminappsummary')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Apps className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Apps" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                {this.props.auth.isAdminUser() &&
                <ListItemButton selected={this.isAlreadyOnPath('templateappsearch')} onClick={this.goTo.bind(this, 'templateappsearch')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Apps  className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Template apps" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                }
                {this.props.auth.isAdminUser() &&
                <ListItemButton selected={this.isAlreadyOnPath('bindcards')} onClick={this.goTo.bind(this, 'bindcards')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <AccountBalanceWallet  className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="BindCards" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                }
              </List>
            )}

            {/* this.props.auth.isAuthenticatedCustomer() && this.props.auth.isTransferredCustomer() && (
              <List className={this.props.narrow ? classes.listNarrow : classes.list}>
                <ListItemButton selected={this.isAlreadyOnPath('subscriptioncreate')} onClick={this.goTo.bind(this, 'subscriptioncreate')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Add className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Buy&nbsp;subscription" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
              </List>
            )*/}

            {this.props.auth.isAuthenticatedReseller() && (
              <List className={this.props.narrow ? classes.listNarrow : classes.list}>
                {this.props.narrow !== true && subOrder &&
                <ListSubheader id="customer_action_list" className={classes.listSubheader}>
                  <Typography variant="overline" className={classes.subheaderText}>Customer accounts</Typography>
                </ListSubheader>}
                {subOrder &&
                <React.Fragment>
                <ListItemButton selected={this.isAlreadyOnPath('subscriptionorder')} onClick={this.goTo.bind(this, 'subscriptionorder')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Add className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Add&nbsp;subscription" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                </React.Fragment>
                }
                {!subOrder &&
                <ListItemButton selected={this.isAlreadyOnPath('subscriptioncreate')} onClick={this.goTo.bind(this, 'subscriptioncreate')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Add className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Add&nbsp;subscription" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                }
                { showAppCatalog && 
                <ListItemButton selected={this.isAlreadyOnPath('catalog')} onClick={this.goTo.bind(this, 'catalog')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Apps className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Catalog" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                }
                <ListItemButton selected={this.isAlreadyOnPath('customers')} onClick={this.goTo.bind(this, 'customers')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <People className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Customers" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                <ListItemButton selected={this.isAlreadyOnPath('communicationtemplatelist')} onClick={this.goTo.bind(this, 'communicationtemplatelist')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <ContactMail className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="Communications" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
              </List>
            )}

            {this.props.auth.isUnauthenticatedCustomer() && (
              <List className={this.props.narrow ? classes.listNarrow : classes.list}>
                <ListItemButton selected={this.isAlreadyOnPath('mytasks')} onClick={this.goTo.bind(this, 'mytasks')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Assignment className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="My&nbsp;tasks" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                 <ListItemButton selected={this.isAlreadyOnPath('myapps')} onClick={this.goTo.bind(this, 'myapps')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <CloudQueue className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="My&nbsp;project" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                <ListItemButton selected={this.isAlreadyOnPath('paymentsources')} onClick={this.goTo.bind(this, 'fundingsources')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <CreditCard className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="My&nbsp;funding" classes={{primary: classes.primaryText}}/>
                </ListItemButton>
                {showExpensing === true &&
                <ListItemButton selected={this.isAlreadyOnPath('mystatements')} onClick={this.goTo.bind(this, 'mystatements')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <AccountBalance className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="My&nbsp;statements" classes={{primary: classes.primaryText}}/>
                </ListItemButton>}
                {showExpensing === true &&
                <ListItemButton selected={this.isAlreadyOnPath('invoicesummary')} onClick={this.goTo.bind(this, 'invoicesummary')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Receipt className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary={"My " + invoiceName} classes={{primary: classes.primaryText}}/>
                </ListItemButton>}
                {showExpensing === true &&
                <ListItemButton selected={this.isAlreadyOnPath('mycharges')} onClick={this.goTo.bind(this, 'mycharges')} className={classes.item}>
                  <ListItemIcon className={classes.itemIcon}>
                    <MonetizationOn className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText primary="My&nbsp;charges" classes={{primary: classes.primaryText}}/>
                </ListItemButton>}
            </List>
            )}

            {this.props.auth.isAuthenticatedVendor() && (
            <List className={this.props.narrow ? classes.listNarrow : classes.list}>
              <ListItemButton selected={this.isAlreadyOnPath('vendorreseller')} onClick={this.goTo.bind(this, 'vendorreseller')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <People className={classes.icon}/><VendorPendingActionIcon/>
                </ListItemIcon>
                <ListItemText primary="Partners" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <ListItemButton selected={this.isAlreadyOnPath('commprograms')} onClick={this.goTo.bind(this, 'commprograms')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <AttachMoney className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Commissions" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <ListItemButton selected={this.isAlreadyOnPath('payout')} onClick={this.goTo.bind(this, 'payout')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <LocalAtmIcon className={classes.icon}/><VendorPayoutActionIcon/>
                </ListItemIcon>
                <ListItemText primary="Payouts" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <Divider style={{marginBottom: '16px', marginTop: '16px'}}/>
              <ListItemButton selected={this.isAlreadyOnPath('programsettings')} onClick={this.goTo.bind(this, 'programsettings')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <Settings className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Program settings" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <ListItemButton selected={this.isAlreadyOnPath('appsgrid')} onClick={this.goTo.bind(this, 'appsgrid')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <Apps className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="App&nbsp;catalog" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <ListItemButton selected={this.isAlreadyOnPath('landingpages')} onClick={this.goTo.bind(this, 'landingpages')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <Launch className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Landing&nbsp;pages" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <ListItemButton selected={this.isAlreadyOnPath('communicationtemplatelist')} onClick={this.goTo.bind(this, 'communicationtemplatelist')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <ContactMail className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Communications" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
              <Divider style={{marginTop: '16px'}}/>
            </List>
          )}

          {
            (this.props.auth.isAuthenticatedAppBind() || this.props.auth.isAuthenticatedReseller()) && (
              <Divider/>
            )
          }
          <List className={this.props.narrow ? classes.listNarrow : classes.list}>
            {this.props.auth.isAuthenticatedReseller() && this.props.narrow !== true && subOrder &&
            <ListSubheader id="my_action_list" className={classes.listSubheader}>
              <Typography variant="overline" className={classes.subheaderText}>My account</Typography>
            </ListSubheader>}
            {subOrder && false &&
            <React.Fragment>
              <ListItemButton selected={this.isAlreadyOnPath('subscriptioncreateself')} onClick={this.goTo.bind(this, 'subscriptioncreateself')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <Add className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Add&nbsp;subscription" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
            </React.Fragment>}

            { this.props.auth.isAuthenticatedCustomer() && this.props.auth.isTransferredCustomer() &&
            <React.Fragment>
              <ListItemButton selected={this.isAlreadyOnPath('subscriptioncreateself')} onClick={this.goTo.bind(this, 'subscriptioncreateself')} className={classes.item}>
                <ListItemIcon className={classes.itemIcon}>
                  <Add className={classes.icon}/>
                </ListItemIcon>
                <ListItemText primary="Add&nbsp;subscription" classes={{primary: classes.primaryText}}/>
              </ListItemButton>
            </React.Fragment>}

            {(!this.props.auth.isUnauthenticatedCustomer()) &&
            <ListItemButton selected={this.isAlreadyOnPath('settings')} onClick={this.goTo.bind(this, 'settings')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Settings className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;settings" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {(this.props.auth.isAuthenticatedCustomer() || this.props.auth.isAuthenticatedReseller() || this.props.auth.isAuthenticatedVendor()) &&
            <ListItemButton selected={this.isAlreadyOnPath('paymentsources')} onClick={this.goTo.bind(this, 'fundingsources')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <CreditCard className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;funding" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedReseller() && 
            <ListItemButton selected={this.isAlreadyOnPath('myapps')} onClick={this.goTo.bind(this, 'myapps')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <CloudQueue className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;subscriptions" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedCustomer() && this.props.auth.isTransferredCustomer() &&
            <ListItemButton selected={this.isAlreadyOnPath('myapps')} onClick={this.goTo.bind(this, 'myapps')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <CloudQueue className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;subscriptions" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedCustomer() && ! this.props.auth.isTransferredCustomer() &&
            <ListItemButton selected={this.isAlreadyOnPath('myapps')} onClick={this.goTo.bind(this, 'myapps')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <CloudQueue className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;project" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {( this.props.auth.isAuthenticatedCustomer() || this.props.auth.isAuthenticatedReseller() || this.props.auth.isAuthenticatedVendor() ) &&
            <ListItemButton selected={this.isAlreadyOnPath('mystatements')} onClick={this.goTo.bind(this, 'mystatements')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <AccountBalance className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;statements" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedCustomer() &&
            <ListItemButton selected={this.isAlreadyOnPath('invoicesummary')} onClick={this.goTo.bind(this, 'invoicesummary')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Receipt className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary={"My " + invoiceName} classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedReseller() && showDocuments === false &&
            <ListItemButton selected={this.isAlreadyOnPath('invoicesummary')} onClick={this.goTo.bind(this, 'invoicesummary')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Receipt className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary={"My " + invoiceName} classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {this.props.auth.isAuthenticatedReseller() && showDocuments === true &&
            <ListItemButton selected={this.isAlreadyOnPath('rdocuments')} onClick={this.goTo.bind(this, 'rdocuments')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Description className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary={documentLabel} classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {(this.props.auth.isAuthenticatedCustomer() || this.props.auth.isAuthenticatedReseller()) && showExpensing === true &&
            <ListItemButton selected={this.isAlreadyOnPath('mycharges')} onClick={this.goTo.bind(this, 'mycharges')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <MonetizationOn className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="My&nbsp;charges" classes={{primary: classes.primaryText}}/>
            </ListItemButton>}
            {/* 
            <ListItemButton selected={this.isAlreadyOnPath('help')} onClick={this.goTo.bind(this, 'help')} className={classes.item}>
              <ListItemIcon className={classes.itemIcon}>
                <Help className={classes.icon}/>
              </ListItemIcon>
              <ListItemText primary="Help" classes={{primary: classes.primaryText}}/>
            </ListItemButton>
            */}
          </List>
         </Drawer>
        ) }
      </div>
    );
  }
}

export default withStyles(styles)(NavDrawer);
